import Event from '@oppobrowser/lib-browser-event';
import EventEmit from '@oppobrowser/lib-browser-eventEmit';
import template from './index.dot';
import { stat } from '../../js/utils';
import { getIsShowMainAndrelatedNews } from '../../js/utils';
import { $ } from '@js/utils';
import { enterId, getDetailPageMode, browserPartner } from '../../js/constants';
import { weatherBizTracReport } from '@js/native';

import './index.scss';
import Exposure from '../../js/exposure';
import {
  channel,
  isNewPush,
  isPushInfinity,
  isListInfinity,
} from '../../js/constants';
import bgTemplate from './bg.dot';
import moreIconTemplate from './moreIcon.dot';

const EventHandler = {
  showMore(node, event) {
    const article = $('.article');
    const showMore = $('.showMore');
    const shareblock = $('.share-block');
    const meta = $('.document-meta');

    if (article) {
      article.style['height'] = 'auto';
      article.classList.remove('fold');
    }
    showMore && (showMore.style['display'] = 'none');
    shareblock && shareblock.classList.remove('showClass');
    meta && meta.classList.remove('showClass');

    const docId = window.pageData.DOCINFO.docId;
    const cacheData = window.localStorage.getItem('__showMoreCache__') || '[]';
    const docIds = JSON.parse(cacheData);
    // 防止缓存的数据太多
    if (docIds.length > 100) {
      docIds.shift();
    }
    docIds.push(docId);
    window.localStorage.setItem('__showMoreCache__', JSON.stringify(docIds));

    // 派发 showMore 事件
    EventEmit.instance.emit('showMore');

    const statData = this.getStatData();
    console.log('showMore statData', statData);

    // 检查并确保曝光已经发生
    if (!EventHandler.hasExposed) {
      // 手动完成曝光上报
      stat(20084541, 10012, 21006, statData);
      EventHandler.hasExposed = true;
    }
    stat(20084542, 10012, 21006, statData);
  },
  hasExposed: false,
};

export default class Main {
  constructor(el, name, data = {}) {
    this.el = el;
    this._eventHandler = {};
  }

  init() {
    Object.keys(EventHandler).forEach((fn) => {
      if (typeof EventHandler[fn] === 'function') {
        this._eventHandler[fn] = EventHandler[fn].bind(this);
      }
    });
    this._bindEvent();
  }

  _bindEvent() {
    this._comEvent = new Event('click', this.el);
    setTimeout(() => {
      // 延迟激活点击事件
      this._comEvent.registeHandler(this._eventHandler);
    }, 100);
  }

  getStatData() {
    const detailPageMode = getDetailPageMode();
    const { sourceVal } = window.store;
    const docInfo = window.pageData.DOCINFO;
    const statData = {
      url: window.location.href,
      title: docInfo.title,
      source: sourceVal,
      docId: docInfo.docId,
      docSource: channel ? 'push' : '',
      sourceMedia: docInfo.media?.vendor,
      push_source: channel && isNewPush ? 'push_infinity' : channel,
      infinity_source:
        (isPushInfinity() && 'push_infinity') ||
        (isListInfinity() && 'list_infinity') ||
        '',
      enterId,
      detailPageMode,
      docSource: browserPartner === 'weather' ? browserPartner : '',
    };
    return statData;
  }

  dataExposure() {
    const exposurer = new Exposure((node) => {
      // 如果已经曝光过，就直接返回，不再执行曝光逻辑
      if (EventHandler.hasExposed) {
        return;
      }
      const statData = this.getStatData();
      stat(20084541, 10012, 21006, statData);
      EventHandler.hasExposed = true;
    });
    // 监听
    exposurer.observe('.document-media__showMore');
  }

  render() {
    // 使用svg适配无图模式
    this.el.innerHTML = template({
      isShow: window.store.isShowFold.isShow,
      showMoreBg: bgTemplate(),
      moreIcon: moreIconTemplate(),
    });

    this.dataExposure();
  }
}
